var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import ListCell from '@doordash/component-list-cell';
import { Colors } from '@doordash/design-language';
import * as React from 'react';
import styled from 'styled-components';
var OptionsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: ", " solid 1px;\n  width: ", ";\n"], ["\n  border: ", " solid 1px;\n  width: ", ";\n"])), Colors.BorderSecondary, function (_a) {
    var width = _a.width;
    return width;
});
export var FilteredOptions = function (_a) {
    var onSelect = _a.onSelect, options = _a.options, selectedOptionsValues = _a.selectedOptionsValues, displayCheckmarkOnSelected = _a.displayCheckmarkOnSelected, _b = _a.width, width = _b === void 0 ? '500px' : _b;
    var selectedOptionsValuesSet = selectedOptionsValues
        ? new Set(selectedOptionsValues)
        : null;
    if (!options.length) {
        return null;
    }
    return (React.createElement(OptionsContainer, { width: width, "data-anchor-id": "searchableSelectorOptions" }, options.map(function (option, index) {
        var value = option.value, text = option.text;
        var isSelected = (selectedOptionsValuesSet === null || selectedOptionsValuesSet === void 0 ? void 0 : selectedOptionsValuesSet.has(value)) || false;
        return (React.createElement(ListCell, { key: value, "data-anchor-id": "searchableSelectorOptionCell", title: text, onClick: function () {
                onSelect(option);
            }, size: ListCell.Sizes.Small, iconEnd: isSelected && displayCheckmarkOnSelected
                ? { type: ListCell.IconTypes.Check }
                : undefined, isToggleable: true, isSquished: true, isSeparatorVisible: index !== options.length - 1, accessibilityRole: "radio" }));
    })));
};
var templateObject_1;
